export const lightTheme = {
    body: '#f1f1f1',
    text: '#121212',
    toggleBorder: '#e2e2e2',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    backgroundBlend: 'normal',
};

export const darkTheme = {
    body: '#121212',
    text: '#ffffff',
    toggleBorder: '#292929',
    background: `linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%),
         linear-gradient(to top, rgba(255,255,255,0.40) 0%, rgba(0,0,0,0.25) 200%)`,
    backgroundBlend: 'multiply',
};

